import React from "react";
import { NavLink, Link } from "react-router-dom";
import {
    NavbarBrand,
    Navbar,
    Row,
    Container,
    Col,
    Nav,
    NavItem,
    UncontrolledCollapse
} from "reactstrap";

import { authenticationService } from '../../services/authenticationService';

const AuthNavbar = () => {
    const currentUser = authenticationService.currentUserValue;
    return (
        <>
            <Navbar className="navbar-top navbar-horizontal navbar-dark" expand="md">
                <Container className="px-4">
                    <NavbarBrand to="/" tag={Link} className="logo logo-white">
                    </NavbarBrand>
                    <button className="navbar-toggler" id="navbar-collapse-main">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
                        <div className="navbar-collapse-header d-md-none">
                            <Row>
                                <Col className="collapse-brand" xs="6">
                                    <Link to="/" className="logo logo-blue logo-login"></Link>
                                </Col>
                                <Col className="collapse-close" xs="6">
                                    <button
                                        className="navbar-toggler"
                                        type="button"
                                        id="navbar-collapse-main">
                                        <span />
                                        <span />
                                    </button>
                                </Col>
                            </Row>
                        </div>
                        <Nav navbar className="ml-auto navbar-nav">
                            {currentUser ?
                                <>
                                    <NavItem className="nav-item">
                                        <NavLink to="/register" className="nav-link-icon nav-link"><i className="fas fa-home"></i><span className="nav-link-inner--text">Home</span></NavLink>
                                    </NavItem>
                                </>
                                :
                                <>
                                    <NavItem className="nav-item">
                                        <NavLink to="/register" className="nav-link-icon nav-link"><i className="fas fa-user-circle"></i><span className="nav-link-inner--text">Register</span></NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink to="/login" className="nav-link-icon nav-link"><i className="fas fa-key"></i><span className="nav-link-inner--text">Login</span></NavLink>
                                    </NavItem>
                                </>
                            }
                        </Nav>
                    </UncontrolledCollapse>
                </Container>
            </Navbar>
        </>
    );
};

export default AuthNavbar;
